import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="w-full bg-accent-600 py-14 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-6 px-4 text-center md:flex-row md:px-6 md:text-left">
        <div>
          <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
            认出每个人，读懂每个设定
          </h2>
          <p className="mt-2 text-sm text-background-100/90 md:text-base">
            从店主到邻居，从那间店到那个洞——愿这份资料能帮你更快进入《洞洞杂货店》的世界。
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-bold text-accent-800 transition-colors hover:bg-background-100"
          >
            关于本站
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/characters"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950/20 px-5 py-2.5 text-sm font-bold text-background-50 ring-1 ring-inset ring-background-50/40 transition-colors hover:bg-foreground-950/30"
          >
            返回人物介绍
          </Link>
        </div>
      </div>
    </section>
  );
}